import * as api from '@owl-nest/api-client/next'
import { Either } from '@owl-nest/monad'

type ImageUploadOptions = {
  file: File
  lang: api.Lang
  type?: api.ImageType
}

export async function uploadImage(
  slugOrId: string | number,
  { lang, file, type = api.ImageType.SECONDARY }: ImageUploadOptions,
): Promise<api.HttpResult<{ id: number; versions?: Record<string, api.ImageVersion> }>> {
  const result = await api.client('POST /users/:id/images', {
    urlParams: {
      id: String(slugOrId),
    },
    body: { image: file, lang, type },
  })

  return result.caseOf({
    left: (failure) => {
      return Either.left(failure)
    },
    right: (success) => {
      return Either.right(success.body)
    },
  })
}
